<template>
    <div class="border rounded p-3 mb-3">
        <h6>График регулярной заявки</h6>
        <MyCron v-if="schedule.kind === 'cron'" :init-cron="schedule.cron" :show-time="false" @change="set('cron', $event)" />
        <b-row v-else>
            <b-col cols="12" md="6"><b-form-group label="Повторять">
                <b-form-select :value="schedule.kind" :options="kinds" @change="set('kind', $event)" />
            </b-form-group></b-col>
            <b-col v-if="schedule.kind !== 'dates'" cols="12" md="6"><b-form-group :label="schedule.kind === 'weeks' ? 'Интервал, недель' : 'Интервал, месяцев'">
                <b-form-input type="number" min="1" max="120" :value="schedule.interval" @input="set('interval', Number($event))" />
            </b-form-group></b-col>
        </b-row>
        <b-button v-if="schedule.kind !== 'cron'" size="sm" variant="link" class="mb-2 px-0" @click="usePeriods">Выбрать период как в Задачнике</b-button>
        <b-button v-else size="sm" variant="link" class="mb-2 px-0" @click="useDates">Указать отдельные даты</b-button>
        <b-form-group v-if="schedule.kind === 'dates'" label="Даты исполнения" description="Одна дата на строку, в формате ГГГГ-ММ-ДД.">
            <b-form-textarea v-model="datesText" rows="4" @input="set('dates', $event.split(/\s+/).filter(Boolean))" />
        </b-form-group>
        <b-row v-else>
            <b-col cols="12" md="6"><b-form-group :label="schedule.kind === 'cron' ? 'Начало повторений' : 'Первое исполнение'">
                <b-form-input type="date" :value="schedule.startDate" @input="set('startDate', $event)" />
            </b-form-group></b-col>
            <b-col cols="12" md="6"><b-form-group label="Окончание" description="Оставьте пустым — до отмены серии.">
                <b-form-input type="date" :value="schedule.endDate" @input="set('endDate', $event || null)" />
            </b-form-group></b-col>
        </b-row>
        <b-form-group label="Создавать заявку за … календарных дней до исполнения">
            <b-form-input type="number" min="0" max="365" :value="schedule.leadDays" @input="set('leadDays', Number($event))" />
        </b-form-group>
        <b-alert v-if="preview.error" show variant="warning">{{ preview.error }}</b-alert>
        <div v-else class="small">
            <strong>{{ preview.description }}</strong>
            <div>Ближайшие даты: {{ preview.dates.join(', ') }}</div>
            <div class="text-muted">Срок — конец дня по Минску. Если числа нет в месяце, используется последний день. Выходные не переносятся.</div>
        </div>
    </div>
</template>
<script>
import MyCron from '@/views/Tasks/TaskCard/TaskDate/MyCron/MyCron.vue';
const recurrence = require('@/utils/requestRecurrence');
export default {
    components: {MyCron},
    props: {value: {type: Object, default: () => ({})}},
    data() { return {datesText: (this.value.dates || []).join('\n')}; },
    watch: {
        'value.dates'(dates) {
            if (JSON.stringify(dates || []) !== JSON.stringify(this.datesText.split(/\s+/).filter(Boolean))) {
                this.datesText = (dates || []).join('\n');
            }
        }
    },
    computed: {
        schedule() {
            const value = {kind: 'cron', cron: '0 0 * * *', interval: 1, startDate: '', endDate: null, leadDays: 5, dates: [], ...this.value};
            // Display compatible saved interval schedules in the same editor without changing their dates.
            const start = new Date(value.startDate + 'T00:00:00Z');
            if (!Number.isFinite(start.getTime())) return value;
            if (value.kind === 'weeks' && Number(value.interval) === 1) return {...value, kind: 'cron', cron: `0 0 * * ${start.getUTCDay()}`};
            if (value.kind === 'months' && Number(value.interval) > 0 && 12 % Number(value.interval) === 0) {
                const months = [];
                for (let i = 0; i < 12; i += Number(value.interval)) months.push((start.getUTCMonth() + i) % 12 + 1);
                return {...value, kind: 'cron', cron: `0 0 ${start.getUTCDate()} ${months.length === 12 ? '*' : months.sort((a, b) => a - b).join(',')} *`};
            }
            return value;
        },
        kinds() { return [{value: 'months', text: 'Каждые N месяцев'}, {value: 'weeks', text: 'Каждые N недель'}, {value: 'dates', text: 'По выбранным датам'}]; },
        preview() {
            try { const schedule = recurrence.normalizeSchedule(this.schedule);
                const dates = recurrence.nextDates(schedule, schedule.startDate, 6);
                if (!dates.length) return {error: 'В выбранном периоде нет дат исполнения.'};
                return {description: recurrence.describe(schedule), dates};
            } catch (error) { return {error: error.message}; }
        }
    },
    methods: {
        set(key, value) { this.$emit('input', {...this.schedule, [key]: value}); },
        usePeriods() {
            this.$emit('input', {...this.schedule, kind: 'cron', cron: '0 0 * * *'});
        },
        useDates() {
            const dates = this.schedule.dates || [];
            this.$emit('input', {...this.schedule, kind: 'dates', dates: dates.length ? dates : [this.schedule.startDate].filter(Boolean)});
        }
    }
};
</script>
